import { CircularProgress } from "@material-ui/core";
import { Heading } from "components/designV2/heading/heading";
import {
  PageHeaderRow,
  PageLayout,
} from "components/designV2/layout/pageLayout";
import { StatusBanner } from "components/designV2/statusBanner/statusBanner";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { ColorV2 } from "config/colors";
import { isSettingEnabled } from "model/settings.logic";
import { useTranslation } from "react-i18next";
import { Tips } from "web-apps/company/components/tips/tips.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const TipsPage = (): JSX.Element | null => {
  const [companyState] = useCompanyStore();
  const { t } = useTranslation();

  const settingsLoaded = companyState.companySettings.length > 0;
  const hasTipModule = isSettingEnabled(
    companyState.companySettings,
    "CompanyShowTipModule",
  );

  if (!companyState.isLoading && settingsLoaded && !hasTipModule) {
    return null;
  }

  return (
    <PageLayout>
      <PageHeaderRow>
        <Heading level="h2">{t("Tips.Title")}</Heading>
      </PageHeaderRow>
      {companyState.isLoading || !settingsLoaded ? (
        <LoggedOutPageContainer>
          <CircularProgress />
        </LoggedOutPageContainer>
      ) : companyState.company?.verified ? (
        <Tips />
      ) : (
        <StatusBanner
          iconName="v2/clock"
          label={t("GigsCompany.UnverifiedAccount")}
          subLabel={t("GigsCompany.UnverifiedAccountDetails")}
          textColor={ColorV2.NegativeRed}
          backgroundColor={ColorV2.White}
        />
      )}
    </PageLayout>
  );
};
